// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Utils
import { toAlphaCase } from 'NewAngular/utils/string-utils';
// Modules
import { PromptModalModule } from '../modals/prompt-modal/prompt-modal.module';
// Component
import { PromptModalComponent } from '../modals/prompt-modal/prompt-modal.component';
import { SelectedItemOperationValue } from 'NewAngular/enums/selected-item-operation-value.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../modals/prompt-modal/prompt-modal.component";
const _c0 = ["promptModalComponent"];
const requiredItemAttrs = ['id', 'itemType', 'itemTypeDescription'];
function isRenameModalItem(value) {
    return value && requiredItemAttrs.every((attr) => attr in value);
}
export class RenameModalComponent {
    set item(value) {
        if (!isRenameModalItem(value)) {
            throw new Error(`ValueError. Item is missing required attributes: ${requiredItemAttrs}`);
        }
        this._item = value;
    }
    get item() {
        return this._item;
    }
    constructor(store) {
        this.store = store;
        this.renameItemHandler = new EventEmitter();
        this.toAlphaCase = toAlphaCase;
        this._item = null;
    }
    ngAfterViewInit() {
        this.selectedOperationSubscription = this.store
            .select(this.selectedOperationSlice)
            .subscribe((selectedOperation) => {
            if (selectedOperation?.operation === SelectedItemOperationValue.RENAME) {
                this.item = selectedOperation.item;
                this.modal.openModal();
            }
        });
    }
    ngOnDestroy() {
        this.selectedOperationSubscription.unsubscribe();
    }
    closeModalHandler() {
        this.store.dispatch(this.clearSelectedOperationAction);
    }
    renameHandler(name) {
        if (this.item === null || name === '' || this.item.name === name)
            return;
        this.renameItemHandler.emit({
            item: this.item,
            name,
        });
        this.modal.closeModal();
    }
}
RenameModalComponent.ɵfac = function RenameModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RenameModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
RenameModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RenameModalComponent, selectors: [["ycn-rename-modal"]], viewQuery: function RenameModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
    } }, inputs: { selectedOperationSlice: "selectedOperationSlice", clearSelectedOperationAction: "clearSelectedOperationAction" }, outputs: { renameItemHandler: "renameItemHandler" }, decls: 2, vars: 5, consts: [["promptModalComponent", ""], [3, "closeModalHandler", "promptHandler", "promptButtonText", "promptHeader", "promptPlaceholder", "modalTestId", "maxInputLength"]], template: function RenameModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-prompt-modal", 1, 0);
        i0.ɵɵlistener("closeModalHandler", function RenameModalComponent_Template_ycn_prompt_modal_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModalHandler()); })("promptHandler", function RenameModalComponent_Template_ycn_prompt_modal_promptHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.renameHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("promptButtonText", "Rename")("promptHeader", ctx.item === null ? "" : "Rename " + ctx.toAlphaCase(ctx.item.itemTypeDescription))("promptPlaceholder", ctx.item === null ? "New name" : ctx.item.name)("modalTestId", "rename-pdf-report-template")("maxInputLength", 255);
    } }, dependencies: [PromptModalModule, i2.PromptModalComponent], encapsulation: 2 });
